import { addBroadcastMessageHandler, removeBroadcastMessageHandler } from 'calling-cross-tab-library/external/broadcastMessageHandler';
import { useEffect, useRef } from 'react';
import { END_CALL_ON_DEVICE_MESSAGE, KEYPAD_NUMBER_PRESS_DEVICE_MESSAGE, MUTE_DEVICE_MESSAGE, SELECT_SPEAKER_DEVICE_MESSAGE, SELECT_MICROPHONE_DEVICE_MESSAGE, REFRESH_TAB_MESSAGE, SET_THREAD_ID, INITIATE_OUTBOUND_CALL_MESSAGE, TOGGLE_CALL_ON_HOLD_MESSAGE, ANSWER_TRANSFER_REQUEST_MESSAGE, REJECT_TRANSFER_REQUEST_MESSAGE, INITIATE_TRANSFER_REQUEST_MESSAGE, CONFIRM_TRANSFER_HANDOFF_MESSAGE, CANCEL_TRANSFER_REQUEST_MESSAGE, TOGGLE_RECORDING_MESSAGE, TOGGLE_RECORDING_MODAL_MESSAGE, CLOSE_ONE_PARTY_CONSENT_RECORDING_ALERT_MESSAGE, ACCEPT_INBOUND_CALL_MESSAGE, DECLINE_INBOUND_CALL_MESSAGE, COMPLETE_CALL_MESSAGE, UPDATE_CALL_PROVIDER_MESSAGE } from 'calling-lifecycle-messages/deviceEventConstants';
export function useWorkerBroadcastEventHandler({
  onDefaultEvent,
  onEndCallMessage,
  onKeyPress,
  onMuteMessage,
  onSelectSpeakerMessage,
  onSelectMicrophoneMessage,
  onThreadIdMessage,
  onInitiateOutboundCallMessage,
  onToggleHoldMessage,
  onRefreshTabMessage,
  onAnswerTransferRequest,
  onRejectTransferRequest,
  onConfirmTransferHandoff,
  onCancelTransferRequest,
  onInitiateTransferRequest,
  onToggleRecordingMessage,
  onToggleRecordingModalMessage,
  onCloseOnePartyConsentRecordingAlertMessage,
  onAcceptInboundCallMessage,
  onDeclineInboundCallMessage,
  onCompleteCallMessage,
  onUpdateCallProviderMessage
}) {
  const defaultHandlers = {};
  const handlers = useRef(defaultHandlers);
  handlers.current[END_CALL_ON_DEVICE_MESSAGE] = onEndCallMessage;
  handlers.current[MUTE_DEVICE_MESSAGE] = onMuteMessage;
  handlers.current[SELECT_SPEAKER_DEVICE_MESSAGE] = onSelectSpeakerMessage;
  handlers.current[SELECT_MICROPHONE_DEVICE_MESSAGE] = onSelectMicrophoneMessage;
  handlers.current[KEYPAD_NUMBER_PRESS_DEVICE_MESSAGE] = onKeyPress;
  handlers.current[INITIATE_OUTBOUND_CALL_MESSAGE] = onInitiateOutboundCallMessage;
  handlers.current[REFRESH_TAB_MESSAGE] = onRefreshTabMessage;
  handlers.current[SET_THREAD_ID] = onThreadIdMessage;
  handlers.current[TOGGLE_CALL_ON_HOLD_MESSAGE] = onToggleHoldMessage;
  handlers.current[ANSWER_TRANSFER_REQUEST_MESSAGE] = onAnswerTransferRequest;
  handlers.current[REJECT_TRANSFER_REQUEST_MESSAGE] = onRejectTransferRequest;
  handlers.current[CONFIRM_TRANSFER_HANDOFF_MESSAGE] = onConfirmTransferHandoff;
  handlers.current[CANCEL_TRANSFER_REQUEST_MESSAGE] = onCancelTransferRequest;
  handlers.current[INITIATE_TRANSFER_REQUEST_MESSAGE] = onInitiateTransferRequest;
  handlers.current[TOGGLE_RECORDING_MESSAGE] = onToggleRecordingMessage;
  handlers.current[TOGGLE_RECORDING_MODAL_MESSAGE] = onToggleRecordingModalMessage;
  handlers.current[CLOSE_ONE_PARTY_CONSENT_RECORDING_ALERT_MESSAGE] = onCloseOnePartyConsentRecordingAlertMessage;
  handlers.current[ACCEPT_INBOUND_CALL_MESSAGE] = onAcceptInboundCallMessage;
  handlers.current[DECLINE_INBOUND_CALL_MESSAGE] = onDeclineInboundCallMessage;
  handlers.current[COMPLETE_CALL_MESSAGE] = onCompleteCallMessage;
  handlers.current[UPDATE_CALL_PROVIDER_MESSAGE] = onUpdateCallProviderMessage;
  const onDefaultEventRef = useRef(onDefaultEvent);
  onDefaultEventRef.current = onDefaultEvent;
  useEffect(() => {
    const handleOnReceiveMessageFromHost = message => {
      const {
        type
      } = message;
      const eventHandler = handlers.current[type];
      if (typeof eventHandler === 'function') {
        eventHandler(message);
      }
      if (onDefaultEventRef && onDefaultEventRef.current) onDefaultEventRef.current(message);
    };
    addBroadcastMessageHandler(handleOnReceiveMessageFromHost);
    return () => {
      removeBroadcastMessageHandler(handleOnReceiveMessageFromHost);
    };
  }, []);
}